export function $(selector: string): HTMLElement {
  return document.querySelector(selector)!;
}

export function $all(selector: string): NodeListOf<HTMLElement> {
  return document.querySelectorAll(selector);
}

export function show(el: HTMLElement): void {
  el.classList.remove('hidden');
}

export function hide(el: HTMLElement): void {
  el.classList.add('hidden');
}

export function formatMoney(amount: number): string {
  return `$${amount.toLocaleString()}`;
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (text) el.textContent = text;
  return el;
}
